import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgStrategicElement = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="m13.38 12.072 1.325-.814 3.47 2.085q.432.26.629.505.196.246.196.582 0 .33-.196.576-.195.246-.63.505l-5.254 3.173q-.264.154-.487.232a1.19 1.19 0 0 1-.873 0q-.21-.078-.48-.232l-5.255-3.173q-.432-.26-.629-.505A.9.9 0 0 1 5 14.431q0-.338.196-.583.195-.246.63-.506l3.61-2.168 1.34.807-4.031 2.38q-.04.027-.04.07 0 .042.04.07l4.978 2.934q.155.09.277.091.116 0 .277-.091l4.971-2.934q.048-.028.048-.07t-.048-.07zM12 13.146q-.223 0-.44-.077-.21-.084-.48-.246L5.825 9.664q-.432-.266-.629-.512A.9.9 0 0 1 5 8.57q0-.33.196-.575.195-.246.63-.505l5.254-3.166q.27-.162.48-.239Q11.777 4 12 4q.216 0 .433.084.223.077.487.239l5.255 3.166q.432.26.629.505.196.246.196.575a.9.9 0 0 1-.196.583q-.195.246-.63.512l-5.254 3.16q-.264.16-.487.245a1.3 1.3 0 0 1-.433.077"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgStrategicElement);
export default ForwardRef;
